import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { IPaginationProps } from '@/@types/posts';

function Pagination({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
  className,
}: IPaginationProps) {
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  const canGoPrev = currentPage > 1;
  const canGoNext = currentPage < totalPages;

  return (
    <div
      className={cn(
        'flex items-center justify-between pt-4',
        className
      )}
    >
      <span className="text-[13px] text-foreground-placeholder">
        Showing {startItem}-{endItem} of {totalItems} posts
      </span>

      <div className="flex items-center gap-2">
        {/* Previous Button */}
        <button
          onClick={() => canGoPrev && onPageChange(currentPage - 1)}
          disabled={!canGoPrev}
          className={cn(
            'flex items-center gap-1.5 rounded-md border border-border px-3 py-2 text-[13px] font-medium transition-colors',
            canGoPrev
              ? 'text-foreground-muted hover:bg-background-card'
              : 'cursor-not-allowed text-foreground-placeholder opacity-50'
          )}
        >
          <ChevronLeft className="h-3.5 w-3.5" />
          <span>Previous</span>
        </button>

        {/* Current Page */}
        <span className="flex items-center justify-center rounded-md bg-primary-foreground px-3.5 py-2 text-[13px] font-semibold text-primary">
          {currentPage}
        </span>

        {/* Next Button */}
        <button
          onClick={() => canGoNext && onPageChange(currentPage + 1)}
          disabled={!canGoNext}
          className={cn(
            'flex items-center gap-1.5 rounded-md border border-border bg-background-card px-3 py-2 text-[13px] font-medium transition-colors',
            canGoNext
              ? 'text-foreground-muted hover:bg-border'
              : 'cursor-not-allowed text-foreground-placeholder opacity-50'
          )}
        >
          <span>Next</span>
          <ChevronRight className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}

export { Pagination };
